import { HTTP_INTERCEPTORS, HttpStatusCode } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import {
    HttpEvent,
    HttpInterceptor,
    HttpHandler,
    HttpRequest,
    HttpResponse,
    HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { tap } from 'rxjs/operators';

import { EndPointApi } from './endpointapi';
import { AuthService } from '@service/auth.service';
import { HEADER_REQUEST_TOKEN_KEY } from 'ops/common/auth/AuthConfig';
import { Router } from '@angular/router';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    private domain: string;

    readonly signInUrl = '/api/ops/signin';

    constructor(
        private injector: Injector,
        private router: Router,
    ) {
        this.domain = EndPointApi.iApiDomain();
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (req.method === 'GET' || req.url === `${this.domain}${this.signInUrl}`) {
            const modifiedReq = req.clone({ withCredentials: true });
            return next.handle(modifiedReq);
        } else {
            const authService = this.injector.get(AuthService);
            const accessToken = authService.getCurrentUserToken();
            if (accessToken) {
                req = req.clone({
                    headers: req.headers.set(HEADER_REQUEST_TOKEN_KEY, accessToken),
                    withCredentials: true,
                });
            }

            return next.handle(req).pipe(
                tap({
                    next: (event: HttpEvent<any>): any => {
                        if (event instanceof HttpResponse) {
                            if (event.body?.redirect) {
                                return this.router.navigate(['/settings']);
                            }
                            return event;
                        }
                    },
                    error: (err: any) => {
                        const authService = this.injector.get(AuthService);
                        if (err instanceof HttpErrorResponse) {
                            if (err.status == HttpStatusCode.Forbidden) {
                                authService.showNotificationOverlay();
                            } else if (err.status !== HttpStatusCode.Unauthorized) {
                                return throwError(() => err);
                            }
                        }
                    },
                }),
            );
        }
    }
}

export const httpInterceptorProviders = {
    provide: HTTP_INTERCEPTORS,
    useClass: AuthInterceptor,
    multi: true,
};
